import React from 'react';
import { DroneDeployProvider } from 'containers/jobsite/tabs/jobsitePulse/components/drones';
import { styles } from './styles';
import { MainCamera } from './MainCamera';
import { CamerasList } from './CamerasList';

export function CamerasPanel(): React.ReactElement {
  return (
    <DroneDeployProvider>
      <div className={styles.root}>
        <MainCamera />
        <CamerasList />
      </div>
    </DroneDeployProvider>
  );
}
